import {
  Anchor,
  Box,
  Button,
  Divider,
  Flex,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import MultiPlacerLogo from "../components/MultiPlacerLogo";
import loginClasses from "./LoginPage.module.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAccessToken } from "../useAccessToken";

const LoginPage = ({ internalOnly = true }) => {
  const { instance } = useMsal();
  const location = useLocation();
  const fromPath = (location.state as any)?.from?.pathname ?? "/";
  const { accessToken } = useAccessToken();

  // Om redan inloggad – gå till önskad sida
  if (accessToken) return <Navigate to={fromPath} replace />;

  return (
    <Flex w="100%" h="100dvh" gap={0}>
      <Box className={loginClasses.imageBox}>
        <MultiPlacerLogo height={50} width={150} className={loginClasses.multiLogo} />
        <Text className={loginClasses.logoSubHeader}>
          KI-drevet prosjektering av tekniske installasjoner
        </Text>
      </Box>
      <Stack w={450} h="100%" justify="space-between" align="center" p="1em" bg="white">
        <Box />
        {internalOnly === true ? (
          <Stack py={30} align="center">
            <h2
              style={{
                color: "#272E35",
                fontWeight: 400,
                fontSize: "1.6em",
                marginBottom: "14px",
              }}
            >
              Enterprise logg inn
            </h2>
            <img src="/images/signInImage.png" style={{ height: "250px" }} />
            <Button
              w="250px"
              mt="sm"
              onClick={() =>
                instance.loginRedirect({
                  ...loginRequest,
                  redirectStartPage: fromPath, // ← kom tillbaka efter login
                })
              }
            >
              Single Sign-on
            </Button>
            <Paper bg="gray.1" p="md" mt="sm">
              <Text size="sm" c="gray.6">
                Enterprise Single Sign-On (SSO) gjør det mulig å bruke sitt eksisterende SAML/
                LDAP-autentiseringssystem for pålogging til Multiconsult applikasjoner. Les mer om{" "}
                <Anchor href="#">Enterprise SSO</Anchor> eller <Anchor href="#">kontakt oss</Anchor>{" "}
                for å komme i gang.
              </Text>
            </Paper>
            <Text size="xs" c="dimmed" mt="sm">
              Les om{" "}
              <Anchor href="#" size="xs">
                våre betingelser
              </Anchor>{" "}
              og{" "}
              <Anchor href="#" size="xs">
                retningslinjer for personvern
              </Anchor>
            </Text>
          </Stack>
        ) : (
          <Box px={45} py={30}>
            <h2
              style={{
                fontWeight: 400,
                fontSize: "1.6em",
                marginBottom: ".7em",
                marginTop: ".3em",
              }}
            >
              Logg inn
            </h2>
            <Text c="dimmed" size="sm" mb={2}>
              Har du ikke en konto?{" "}
              <Anchor href="#" size="sm">
                Opprett en konto her
              </Anchor>
            </Text>
            <Stack mb={15}>
              <TextInput label="E-post" placeholder="" required />
              <PasswordInput label="Passord" placeholder="" required />
              <Box w="100%" style={{ textAlign: "right" }}>
                <Anchor href="#" size="sm">
                  Glemt passord?
                </Anchor>
              </Box>
            </Stack>
            <Button fullWidth>Logg inn</Button>
            <Divider label="eller" labelPosition="center" my="md" />
            <Button fullWidth variant="outline">
              Logg inn med Multiconsult-bruker
            </Button>
            <Text size="xs" c="dimmed" mt={30}>
              Les om{" "}
              <Anchor href="#" size="xs">
                våre betingelser
              </Anchor>{" "}
              og{" "}
              <Anchor href="#" size="xs">
                retningslinjer for personvern
              </Anchor>
            </Text>
          </Box>
        )}

        <img src="/images/logo/multiconsultDark.png" style={{ height: "80px" }} />
      </Stack>
    </Flex>
  );
};

export default LoginPage;
